// New PINs are exactly PIN_LENGTH digits. Verification tolerates legacy shorter
// PINs (MIN_PIN) so a previously-set PIN never locks the owner out after a bump.
export const PIN_LENGTH = 6
export const MIN_PIN = 4

const pinKey = (orgId: string) => `shelvi_operator_pin_${orgId}`
const activeKey = (orgId: string) => `shelvi_operator_active_${orgId}`

export async function hashPin(pin: string): Promise<string> {
  const buf = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(pin))
  return Array.from(new Uint8Array(buf)).map(b => b.toString(16).padStart(2, '0')).join('')
}

export function getStoredPinHash(orgId: string): string | null {
  try { return localStorage.getItem(pinKey(orgId)) } catch { return null }
}

export function getIsOperatorActive(orgId: string): boolean {
  try { return localStorage.getItem(activeKey(orgId)) === 'true' } catch { return false }
}

export function setOperatorActive(orgId: string, active: boolean): void {
  try { localStorage.setItem(activeKey(orgId), active ? 'true' : 'false') } catch {}
}

export function storePinHash(orgId: string, hash: string): void {
  try { localStorage.setItem(pinKey(orgId), hash) } catch {}
}

export function clearPinStorage(orgId: string): void {
  try {
    localStorage.removeItem(pinKey(orgId))
    localStorage.removeItem(activeKey(orgId))
  } catch {}
}

export async function verifyStoredPin(orgId: string, pin: string): Promise<boolean> {
  const stored = getStoredPinHash(orgId)
  if (!stored) return false
  return (await hashPin(pin)) === stored
}
